// @flow

import * as React from "react";
import { useSelector } from "react-redux";
import Helmet from "react-helmet";

import Config from "../../constants/Config";

type PropsType = {
    title?: string,
    description?: string,
    url?: string,
    image?: {
        url: string,
        width: number,
        height: number,
    },
};

const CustomMeta = (props: PropsType) => {
    const defaultTileImage = useSelector((state: any): any => {
        return state.options.default_tile_image;
    });

    const siteName = Config.siteName;
    const pageTitle = props.title
        ? `${props.title}${Config.siteNameSeperator}${siteName}`
        : siteName;
    const image = props.image || defaultTileImage;

    return (
        <Helmet>
            <title>{pageTitle}</title>

            {props.description ? (
                <meta name="description" content={props.description} />
            ) : null}

            <link rel="canonical" href={props.url || document.location.href} />

            <meta property="og:type" content={props.type || "website"} />

            <meta property="og:title" content={pageTitle} />

            {props.description ? (
                <meta property="og:description" content={props.description} />
            ) : null}

            <meta
                property="og:url"
                content={props.url || document.location.href}
            />

            <meta property="og:site_name" content={siteName} />

            {image ? <meta property="og:image" content={image.url} /> : null}
            {image ? (
                <meta property="og:image:width" content={image.width} />
            ) : null}
            {image ? (
                <meta property="og:image:height" content={image.height} />
            ) : null}

            {props.children}
        </Helmet>
    );
};

export default CustomMeta;
